// extracted by mini-css-extract-plugin
export default {"srOnly":"FeedbackStars_srOnly__H5z-6","container":"FeedbackStars_container__tRy+A"};